export function getNextPath(paths, currentPath) {
  const pos = paths.indexOf(currentPath);
  return paths.includes(paths[pos + 1]) ? paths[pos + 1] : null;
}

export function getPrevPath(paths, currentPath) {
  const pos = paths.indexOf(currentPath);
  return paths.includes(paths[pos - 1]) ? paths[pos - 1] : null;
}



// WEBPACK FOOTER //
// ../core/src/utils/path.js